var _path, _rect, _rect2, _path2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path3, _path4, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGettikTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1221,
    height: 157,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.639 69.53l62.898-31.445a3.996 3.996 0 011.313-.394l144.128-17.287c.91-.11 1.83.097 2.606.586l154.233 97.06a3.996 3.996 0 001.668.587l233.475 27.15a4.004 4.004 0 003.145-1.006L748.1 30.845a3.999 3.999 0 012.448-1.026l266.032-15.652c.55-.032 1.1.049 1.61.238l185.47 68.098",
    stroke: "#848484",
    strokeWidth: 1.5,
    strokeDasharray: "4 4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.412,
    y: 50.747,
    width: 39.305,
    height: 39.305,
    rx: 19.653,
    fill: "#fff",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.666,
    y: 57,
    width: 26.728,
    height: 26.728,
    rx: 13.364,
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.353 67.575c-2.375-1.71-5.088-3.116-8.061-3.462-2.58-.362-5.428.117-7.417 1.846-1.312 1.106-1.82 2.805-2.136 4.403-.105 1.066-.146 2.192.235 3.215.238.607 1.003.472 1.525.423.274.708.76 1.403 1.526 1.66.829.258 1.834.116 2.45-.512.41-.376.592-.903.783-1.4 2.727.028 5.457.033 8.184-.022.158.53.367 1.078.796 1.46.641.608 1.643.71 2.47.464.77-.256 1.219-.97 1.527-1.657.515.027 1.298.223 1.538-.388.24-.654.175-1.375.146-2.058-.059-1.155-.755-2.305-1.867-2.777-.64-.29-1.128-.801-1.7-1.195zm-3.2-.549a50.835 50.835 0 01-.049 1.537c-1.846.023-3.694-.017-5.541-.019.003-1.08-.052-2.165.025-3.246 1.96.147 3.854.808 5.564 1.728zm-6.847-1.768c.036 1.104.028 2.209 0 3.313-1.903-.013-3.806.009-5.709-.008.342-.919 1.005-1.712 1.841-2.251 1.138-.742 2.524-.976 3.868-1.054zm9.05 3.315c-.318 0-.639-.008-.96-.02l-.001-.66c.336.206.66.43.962.68zm1.116 3.908c.624.39.477 1.49-.273 1.653-.54.21-1.034-.169-1.34-.566.037-.334.003-.716.268-.974.345-.328.952-.374 1.345-.113zm-13.187-.076c.448.211.672.778.451 1.219-.174.47-.769.657-1.234.532-.6-.157-.863-.954-.515-1.44.27-.408.861-.542 1.298-.31z",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 212.955,
    y: 7.56,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 216.809,
    y: 11.414,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 374.939,
    y: 108.132,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 378.793,
    y: 111.985,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 608.955,
    y: 132.867,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 612.809,
    y: 136.721,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1181.62,
    y: 64.918,
    width: 39.305,
    height: 39.305,
    rx: 19.653,
    fill: "#fff",
    fillOpacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1187.91,
    y: 71.207,
    width: 26.728,
    height: 26.728,
    rx: 13.364,
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.67 84.5h-2.11m0 0c0 1.96-.78 3.839-2.17 5.225a7.367 7.367 0 01-5.22 2.164m7.39-7.389c0-1.96-.78-3.84-2.17-5.226a7.366 7.366 0 00-5.22-2.163m0-2.111v2.111m0 0c-1.96 0-3.84.777-5.23 2.163a7.409 7.409 0 00-2.16 5.225c0 1.96.78 3.84 2.16 5.225a7.409 7.409 0 005.23 2.165m-9.5-7.389h2.11m7.39 9.5v-2.111",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.17 88.722c1.12 0 2.19-.445 2.98-1.236a4.233 4.233 0 001.24-2.986c0-1.12-.45-2.194-1.24-2.985a4.206 4.206 0 00-2.98-1.237 4.229 4.229 0 00-4.23 4.222 4.229 4.229 0 004.23 4.222z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 734.615,
    y: 17.988,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 738.469,
    y: 21.841,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1002.62,
    y: 0.988,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1006.47,
    y: 4.841,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGettikTimeline);
export default __webpack_public_path__ + "static/media/gettik-timeline.0be81e63b5dc0d522b7ccedc681f75b6.svg";
export { ForwardRef as ReactComponent };